import { DONATION_ROUTES, WEL_MARKET_ROUTES } from '@/constants';

import { findRoute } from './findRoute';

const SERVICE_SCOPED_ROOTS = [
  DONATION_ROUTES.HOME.pathname,
  WEL_MARKET_ROUTES.HOME.pathname,
  //* 알림톡 링크 착지(앱 실행 화면)는 탭바가 없어야 하고, 탭바 prefetch가 방문마다 다른 탭을 렌더하게 만든다
  '/link',
];

//* 고기부·웰마켙은 자체 하단 크롬(FloatingBnbController)을 쓴다. 라우트 등록이 빠지면
//* 아래 `?? true` 폴백이 웰로 탭바를 띄워버리므로 네임스페이스 단위로 먼저 막는다.
const isServiceScopedPath = (pathname: string) =>
  SERVICE_SCOPED_ROOTS.some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  );

/**
 * 웰로 하단 탭바 노출 여부.
 * 탭바를 그리는 쪽(GlobalNavigation)과 그만큼 하단 여백을 확보하는 쪽(GlobalLayout)이
 * 따로 계산하면 탭바 없는 화면에 여백만 남으므로 판정을 여기 하나로 둔다.
 */
export const hasWelloBottomNav = (
  pathname: string | null,
  hideBottomNav: boolean,
) => {
  if (!pathname || hideBottomNav) {
    return false;
  }

  if (isServiceScopedPath(pathname)) {
    return false;
  }

  return findRoute(pathname)?.hasBottomNav ?? true;
};
